module.exports = __webpack_public_path__ + "img/head.8cdaa517.jpg";